
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftBottom100 as ObiThreewayAcuatorGenericInleftBottom100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-bottom-100.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftBottom100 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-bottom-100',
   elementClass: ObiThreewayAcuatorGenericInleftBottom100Element,
   events: {
     
   }
  });
 
 